import React, { FC } from "react";

export interface Props {
    onClick(): void;
}

function getLeftArrowSvg() {
    return (
        <svg viewBox="-5 -18 10 36">
            <path d="M 2.5 -15 L -2.5 0 L 2.5 15" stroke="currentColor" strokeLinecap="square" strokeWidth="4px" fill="none" />
        </svg>
    );
}

const ChevronLeft: FC<Props> = props => {
    return (
        <button onClick={props.onClick} className="xa-chevron">
            {getLeftArrowSvg()}
        </button>
    );
};

export default ChevronLeft;
